// Only record analytics on the deployed site — never during local development
// or testing. True only for a production build served from a non-localhost host,
// so it guards both a dev server (`npm start`) and a prod build run locally
// (e.g. `serve build`). Kept dependency-free so firebase.js and metrics.js can
// both import it without a circular dependency.
export function isTrackingEnabled() {
  if (typeof window === 'undefined') return false;
  if (process.env.NODE_ENV !== 'production') return false;
  const h = window.location.hostname;
  return h !== 'localhost' && h !== '127.0.0.1' && h !== '::1' && h !== '[::1]';
}
